/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { Layout, Button, Card, Space, Popconfirm } from "antd";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { displayMessage, getAPI } from "../../utils/common";
import { ALL_SUBSCRIPTION_PLAN } from "../../constants/api";
import { ERROR_MSG_TYPE, SUCCESS_MSG_TYPE } from "../../constants/messages";
import MonacoEditor from "@monaco-editor/react";

const { Content } = Layout;
function DBManager() {
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState(`
-- Write your SQL queries here
SELECT * FROM users;
  `);

  const handleEditorChange = (value, event) => {
    setCode(value);
  };
  // eslint-disable-next-line no-unused-vars
  const handleTruncate = async () => {
    setLoading(true);
    getAPI(
      ALL_SUBSCRIPTION_PLAN,
      (res) => {
        setLoading(false);
        if (res.status) {
          displayMessage(SUCCESS_MSG_TYPE, res.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Failed to clear plans");
      }
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content className="p-4 bg-white min-h-screen">
        <Card
          title="DB Manager"
          extra={
            <>
              <Space>
                <Popconfirm
                  title="Truncate the Rate Plan"
                  description="Are you sure you want to clear all rate plans? This action cannot be undone."
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    danger
                    loading={loading}
                    disabled={loading}
                    style={{ color: "#fff" }}
                  >
                    Truncate Plans
                  </Button>
                </Popconfirm>
              </Space>
            </>
          }
        >
          <div style={{ height: "500px", width: "100%" }}>
            <MonacoEditor
              height="100%"
              language="sql" // Set the language to SQL
              value={code}
              onChange={handleEditorChange}
              theme="vs-dark" // You can change this to "light" or other themes
              options={{
                wordWrap: "on",
                minimap: { enabled: false }, // Disable minimap if not needed
                fontSize: 14,
                scrollBeyondLastLine: false,
                readOnly: false,
              }}
            />
          </div>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default DBManager;
